import { array, mixed, number, object, ref, string } from 'yup';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';

export const schemaAcc2Acc = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amount: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')
    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount?.currency !== undefined
        ? schema.max(
            ref('fromAccount.balance'),
            ({ max }) =>
              `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${max}  ${useCurrencySymbol(
                fromAccount?.currency
              )}`
          )
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  toAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .nullable()
    .when('fromAccount', {
      is: (fromAccount: any) => fromAccount !== undefined && Object.keys(fromAccount).length > 0,
      then: (schemaThen) => schemaThen.required('Alan hesabın seçilməsi zəruridir'),
    }),
  desc: string()
    .required('Ödənişin təyinatı zəruridir')
    .max(140, 'Maksimum 140 simvol')
    .matches(
      /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.,№:;\n -]*$/,
      'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
    ),
});

export const schemaInBank = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amount: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')
    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount?.currency !== undefined
        ? schema.max(
            ref('fromAccount.balance'),
            ({ max }) =>
              `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${max}  ${useCurrencySymbol(
                fromAccount?.currency
              )}`
          )
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  desc: string()
    .required('Ödənişin təyinatı zəruridir')
    .max(140, 'Maksimum 140 simvol')
    .matches(
      /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.,№:;\n -]*$/,
      'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
    ),
  toAccount: string()
    .required('Məxaric  hesabın seçilməsi zəruridir')
    .max(28, 'IBAN 28 simvoldan ibarət olmalıdır')
    .min(28, 'IBAN 28 simvoldan ibarət olmalıdır')
    .when(['$currencyOfToAccount', 'fromAccount'], ([currencyOfToAccount, fromAccount], schema) => {
      return currencyOfToAccount !== undefined && fromAccount !== undefined
        ? schema.test('currency', 'Hesabın valyutası uyğun deyil', function () {
            return currencyOfToAccount === fromAccount?.currency;
          })
        : schema;
    }),
  contractNumber: string().when('$contractNumberRequiredInBank', ([contractNumberRequiredInBank], schema) => {
    return contractNumberRequiredInBank === undefined || contractNumberRequiredInBank === 'false'
      ? schema.notRequired()
      : schema.required('Müqavilə/Hesab faktura nömrəsi əlavə etmək zəruridir');
  }),
  fileInBank: mixed().when('$fileRequiredInBank', ([fileRequiredInBank], schema) => {
    return fileRequiredInBank === undefined || fileRequiredInBank === 'false'
      ? schema.notRequired()
      : schema.test('required', 'Fayl əlavə etmək zəruridir', (file: any) => {
          if (file.length !== 0) {
            return true;
          }

          return false;
        });
  }),

  customerType: string(),
  beneficiarName: string(),
  beneficiarVoen: string(),
});

export const schemaLocalTransfer = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  commission: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amount: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')
    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount?.currency !== undefined
        ? schema.max(
            ref('fromAccount.balance'),
            ({ max }) =>
              `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${max}  ${useCurrencySymbol(
                fromAccount?.currency
              )}`
          )
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  paymentType: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Ödəniş prosesinin seçilməsi zəruridir'),
  customerType: object()
    .shape({
      label: string(),
      value: string(),
    })
    .when('$customerTypeIsRequired', ([customerTypeIsRequired], schema) => {
      return customerTypeIsRequired
        ? schema.strict().required('Müştəri tipinin seçilməsi zəruridir')
        : schema.notRequired();
    }),
  bankCode: string().when('$customerTypeIsRequired', ([customerTypeIsRequired], schema) => {
    return customerTypeIsRequired
      ? schema
          .required('Benefsiar bankın kodunun əlavə edilməsi zəruridir')
          .max(6, 'Maksimum 6 simvol')
          .min(6, 'Minimum 6 simvol')
      : schema.notRequired();
  }),
  bankName: string(),
  bankAccNumber: string(),
  beneficiarVoen: string().when('$customerTypeVoenIsRequired', ([customerTypeVoenIsRequired], schema) => {
    return customerTypeVoenIsRequired
      ? schema.required('Benefsiarın VÖEN-in əlavə edilməsi zəruridir')
      : schema.notRequired();
  }),
  beneficiarName: string().when('$customerTypeIsRequired', ([customerTypeIsRequired], schema) => {
    return customerTypeIsRequired
      ? schema.required('Benefsiarın adının əlavə edilməsi zəruridir').max(34, 'maksimal simvol sayi 34')
      : schema.notRequired();
  }),
  beneficiarAccNo: string().when('$customerTypeIsRequired', ([customerTypeIsRequired], schema) => {
    return customerTypeIsRequired
      ? schema
          .required('Benefsiarın hesab nömrəsinin əlavə edilməsi zəruridir')
          .max(28, 'IBAN 28 simvoldan ibarət olmalıdır')
          .min(28, 'IBAN 28 simvoldan ibarət olmalıdır')
      : schema.notRequired();
  }),
  ipsType: object()
    .shape({
      title: string(),
      code: string(),
    })
    .strict()
    .when('$ipsIsRequired', ([ipsIsRequired], schema) => {
      return ipsIsRequired ? schema.required('İPS Alias növünün seçilməsi zəruridir') : schema.notRequired();
    }),
  ipsValue: string().when('$ipsIsRequired', ([ipsIsRequired], schema) => {
    return ipsIsRequired ? schema.required('İPS Alias dəyərinin əlavə edilməsi zəruridir') : schema.notRequired();
  }),
  fileInBank: mixed().when(['$fileRequiredLocal', '$selfPayment'], ([fileRequiredLocal, selfPayment], schema) => {
    return fileRequiredLocal && selfPayment
      ? schema.notRequired()
      : fileRequiredLocal
      ? schema.test('required', 'Fayl əlavə etmək zəruridir', (file: any) => {
          if (file.length !== 0) {
            return true;
          }

          return false;
        })
      : schema.notRequired();
  }),
  desc: string()
    .required('Ödənişin təyinatı zəruridir')
    .max(140, 'Maksimum 140 simvol')
    .matches(
      /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.,№:;\n -]*$/,
      'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
    ),
  contractNumber: string().when('$selfPayment', ([selfPayment], schema) => {
    return selfPayment ? schema.notRequired() : schema.required();
  }),
});

export const schemaBudget = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  commission: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amount: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')
    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount?.currency !== undefined
        ? schema.max(
            ref('fromAccount.balance'),
            ({ max }) =>
              `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${max}  ${useCurrencySymbol(
                fromAccount?.currency
              )}`
          )
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  desc: string()
    .required('Ödənişin təyinatı zəruridir')
    .max(140, 'Maksimum 140 simvol')
    .matches(
      /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.,№:;\n -]*$/,
      'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
    ),
  budgetAccNumber: string()
    .required()
    .max(28, 'IBAN 28 simvoldan ibarət olmalıdır')
    .min(28, 'IBAN 28 simvoldan ibarət olmalıdır'),
  orgName: string(),
  orgVoen: string(),
  classCode: string().required(),
  className: string(),
  levelCode: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required(),
  // fileLocalTransfer: string().when('$customerTypeVoenIsRequired', ([customerTypeVoenIsRequired], schema) => {
  //   return !customerTypeVoenIsRequired
  //     ? schema.required('Benefsiarın VÖEN-in əlavə edilməsi zəruridir')
  //     : schema.notRequired();
  // }),
});

export const schemaEdv = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  commission: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amount: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')
    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount?.currency !== undefined
        ? schema.max(
            ref('fromAccount.balance'),
            ({ max }) =>
              `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${max}  ${useCurrencySymbol(
                fromAccount?.currency
              )}`
          )
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  desc: string()
    .required('Ödənişin təyinatı zəruridir')
    .max(140, 'Maksimum 140 simvol')
    .matches(
      /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.,№:;\n -]*$/,
      'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
    ),
  beneficiarBankCode: string(),
  beneficiarBankName: string(),
  beneficiarBankAccNumber: string(),
  beneficiarVoen: string().required().max(10, 'Max 10 simvol').min(10, 'Min 10 simvol'),
  beneficiarName: string().required(),
  beneficiarAccNumber: string(),
  // fileLocalTransfer: string().when('$customerTypeVoenIsRequired', ([customerTypeVoenIsRequired], schema) => {
  //   return !customerTypeVoenIsRequired
  //     ? schema.required('Benefsiarın VÖEN-in əlavə edilməsi zəruridir')
  //     : schema.notRequired();
  // }),
});

export const schemaConversion = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
      balance: number(),
      currency: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  toAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  commission: object()
    .shape({
      label: string(),
      value: string(),
      balance: number(),
      currency: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amountTo: number().transform((value) => (Number.isNaN(value) ? null : value)),
  amountFrom: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')

    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount !== undefined
        ? schema.test({
            name: 'max',
            exclusive: false,
            params: {},
            message: `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${
              fromAccount.balance
            }  ${useCurrencySymbol(fromAccount?.currency)}`,
            test(value) {
              return value <= parseFloat(fromAccount.balance);
            },
          })
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  customerRate: number().when('$checkIndividualConversion', ([checkIndividualConversion], schema) => {
    return checkIndividualConversion
      ? schema.transform((value) => (Number.isNaN(value) ? null : value)).required()
      : schema.notRequired();
  }),
});

export const schemaForeign = object().shape({
  fromAccount: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  commission: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  amount: number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .required('Məbləğin əlavə edilməsi zəruridir')
    .when('fromAccount', ([fromAccount], schema) => {
      return fromAccount?.currency !== undefined
        ? schema.max(
            ref('fromAccount.balance'),
            ({ max }) =>
              `Kifayət qədər vəsait yoxdur, istifadə oluna bilən məbləğ ${max}  ${useCurrencySymbol(
                fromAccount?.currency
              )}`
          )
        : schema.required('Məbləğin əlavə edilməsi zəruridir');
    }),
  country: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Məxaric hesabın seçilməsi zəruridir'),
  swiftBic: string().required('Swift/Bic zəruridir'),
  beneficiarBankName: string(),
  beneficiarAccNumber: string().required('Benefsiarın hesab nömrəsi zəruridir'),
  // .max(28, 'IBAN 28 simvoldan ibarət olmalıdır')
  // .min(28, 'IBAN 28 simvoldan ibarət olmalıdır'),
  beneficiarName: string().required('Benefisiarın adı zəruridir').max(34, 'maksimal simvol sayi 34'),
  beneficiarAddress: string().required('Benefisiarın ünvanı zəruridir'),
  midBankSwiftBic: string().when('$mediatorBank', ([mediatorBank], schema) => {
    return mediatorBank ? schema.required('Vasitəçi bankın Swift BIC kodu zəruridir') : schema.notRequired();
  }),
  midBankName: string(),
  midBankAccNumber: string().when('$mediatorBank', ([mediatorBank], schema) => {
    return mediatorBank
      ? schema.required('Vasitəçi bankın hesab nömrəsi zəruridir')
      : // .max(28, 'IBAN 28 simvoldan ibarət olmalıdır').min(28, 'IBAN 28 simvoldan ibarət olmalıdır')
        schema.notRequired();
  }),
  beneficiarInn: string().when('$selectedCountries', ([selectedCountries], schema) => {
    return selectedCountries === undefined || selectedCountries.value === 'RUS'
      ? schema
          .required()
          .min(10, 'INN minimum 10 simvoldan ibarət olmalıdır')
          .max(12, 'INN maksimum 12 simvoldan ibarət olmalıdır')
      : schema.notRequired();
  }),
  beneficiarKpp: string().when('$selectedCountries', ([selectedCountries], schema) => {
    return selectedCountries === undefined || selectedCountries.value === 'RUS'
      ? schema.required().min(9, 'KPP 9 simvoldan ibarət olmalıdır').max(9, 'KPP 9 simvoldan ibarət olmalıdır')
      : schema.notRequired();
  }),
  fileInBank: mixed().test('required', 'Fayl əlavə etmək zəruridir', (file: any) => {
    if (file.length !== 0) {
      return true;
    }

    return false;
  }),
  invoiceNo: string().when('$avans', ([avans], schema) => {
    return avans
      ? schema
          .required()
          .max(9, 'Gömrük kodu 9 simvoldan ibarət olmalıdır')
          .min(9, 'Gömrük kodu 9 simvoldan ibarət olmalıdır')
      : schema.notRequired();
  }),
  contractNumber: string().required(),
  desc: string()
    .required('Ödənişin təyinatı zəruridir')
    .max(140, 'Maksimum 140 simvol')
    .when('$selectedCountries', ([selectedCountries], schema) => {
      return selectedCountries === undefined || selectedCountries.value !== 'RUS'
        ? schema.matches(
            /^[a-zA-Z0-9.,№:;\n -]*$/,
            'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
          )
        : selectedCountries.value === 'RUS' &&
            schema.matches(
              /^[ЁёА-я0-9.,№:;\n -]*$/,
              'Təyinatda @ # $ ! ? _ & * = < > “ ” ~ / işarələri istifadə edilməməlidir.'
            );
    }),
});
